import { render, staticRenderFns } from "./handgrading_settings.vue?vue&type=template&id=187ecb12&scoped=true&"
import script from "./handgrading_settings.vue?vue&type=script&lang=ts&"
export * from "./handgrading_settings.vue?vue&type=script&lang=ts&"
import style0 from "./handgrading_settings.vue?vue&type=style&index=0&id=187ecb12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ecb12",
  null
  
)

export default component.exports